import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

export default class AlphabetSlider {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.swiper = new Swiper(this.el, {
			slidesPerView: "auto",
			modules: [FreeMode],
			freeMode: {
				enabled: true,
				momentumRatio: 1.125,
			},
		});
	}
}
